import { ReactNode, useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { renderIcon } from 'utils/icon.utils';
import './Accordion.css';

type AccordionProps = {
  title: string;
  children: ReactNode;
  isOpenAccordion: boolean;
};

export const Accordion = ({
  title,
  children,
  isOpenAccordion,
}: AccordionProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(isOpenAccordion);

  return (
    <div className="accordion">
      <div className="accordion-header" onClick={() => setIsOpen(!isOpen)}>
        <span>{title}</span>
        {renderIcon(FiChevronDown, {
          className: `arrow ${isOpen ? 'open' : ''}`,
        })}
      </div>
      {isOpen && <div className="accordion-content">{children}</div>}
    </div>
  );
};
